import { create } from "zustand"

type SurveyStore = {
  hasSurveyBeenTriggered: boolean
  markSurveyAsTriggered: () => void
}

const useSurveyStore = create<SurveyStore>((set) => ({
  hasSurveyBeenTriggered: false,
  markSurveyAsTriggered: () => set({ hasSurveyBeenTriggered: true }),
}))

export default useSurveyStore
